import { render } from "./ModifierModal.vue?vue&type=template&id=45dd1db6&scoped=true"
import script from "./ModifierModal.vue?vue&type=script&lang=js"
export * from "./ModifierModal.vue?vue&type=script&lang=js"

import "./ModifierModal.vue?vue&type=style&index=0&id=45dd1db6&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dd1db6"]])

export default __exports__